import { FuelRequestStateTypes, FuelRequestActionTypes } from "./FuelRequest.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FuelRequestStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FuelRequestReducer = (
  state: FuelRequestStateTypes = INITIAL_STATE,
  action: any
): FuelRequestStateTypes => {
  switch (action.type) {
    case FuelRequestActionTypes.FETCH_ALL_FUEL_REQUEST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelRequestActionTypes.FETCH_ALL_FUEL_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelRequestActionTypes.FETCH_ALL_FUEL_REQUEST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelRequestActionTypes.FETCH_ALL_FUEL_REQUEST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FuelRequestActionTypes.FETCH_ONE_FUEL_REQUEST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelRequestActionTypes.FETCH_ONE_FUEL_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelRequestActionTypes.FETCH_ONE_FUEL_REQUEST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelRequestActionTypes.FETCH_ONE_FUEL_REQUEST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FuelRequestReducer;
